import React from "react"
import bootbox from "bootbox"

export default class CalculatorCard extends React.Component {
	
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	render() {
		// console.log(this.props)
		return (
			<div className="calculator-card" onClick={this.onClick}>
				<div className="wrapper">
					<div className="name">{this.props.name}</div>
					<div className="image"><img src={this.props.image_src} alt={"Stock image of " + this.props.name} /></div>
				</div>
			</div>
		);	
	}

	onClick(e) {
		// e.stopPropagation();
		e.preventDefault();

		var $win = $(window);
    var win_height = $win.height();

    var calculator_modal = bootbox.alert({
      className: 'modal-fullscreen',
      size: 'large',
      message: '<iframe allowfullscreen frameborder="0" height="100%" width="100%" style="margin-top:15px;height:' + (win_height - 180) + 'px" src="' + this.props.url.replace(/http:/, 'https:') + '"></iframe>',
      callback: function () {
        $(window).off('resize.calculator');
      }
    });

    calculator_modal.init(function () {
      $(window).on('resize.calculator', function () {
        var $win = $(window);
        var win_height = $win.height();
        $('.modal-fullscreen iframe').height((win_height - 180));
      });
    });
	}

}